<template>
    <v-app>

  <div id="app">
    <v-progress-linear
      indeterminate
      v-if="isLoading"
      color="primary"
      background-color="white"
      fixed
    ></v-progress-linear>
    <v-toolbar id="app-bar-toolbar" flat color="primary">
      <v-toolbar-title class="text-white bold"><b>Intract Tests</b></v-toolbar-title>
      <v-spacer></v-spacer>      
      <h3 v-if="currentUser" class="userFname text-white"><i class="fas fa-user"></i> {{ currentUser.full_name.split(" ")[0] }} </h3>

      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn v-if="currentUser !== null" to="/" elevation="0" text color="white">All tests</v-btn>
        <v-btn v-if="currentUser !== null" to="/logout" elevation="0" text color="white">Logout</v-btn>   
      </v-toolbar-items>  


      <div class="hidden-md-and-up" v-if="currentUser">
        <v-menu bottom left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="white">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item>
                <v-list-item-title> 
                  <v-btn v-if="currentUser !== null" to="/" text>Home</v-btn>  
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title> 
                  <v-btn v-if="currentUser !== null" to="/logout" text>Logout</v-btn>   
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          </div>
    </v-toolbar>
    
    <transition name="fade" mode="out-in">
      <router-view class="view" />
    </transition>
  </div>
    </v-app>

</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "App",
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'isLoading'])
  },
};
</script>

<style lang="css" scoped>
.user-greetings {
  font-size: 20px;
  margin-right: 10px;
  padding-top: 15px;
}
.userFname{
  margin-right: 10px;
}
.text-white{
  color: white;
}
</style>